"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var makeUrl = function makeUrl(location, key) {
  var output = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'embed';
  var base = 'https://maps.google.com/maps';
  var config = {
    key,
    output,
    q: location
  };
  var url = new URL(base);
  Object.entries(config).forEach((_ref) => {
    var [k, val] = _ref;
    return url.searchParams.append(k.toLowerCase(), val);
  });
  return url;
};

var useStyles = (0, _styles.makeStyles)({
  root: {
    height: 'inherit',
    width: 'inherit',
    display: 'flex'
  }
}, {
  name: 'Mui-WidgetGoogleMaps'
});

var Iframe = (_ref2) => {
  var {
    src,
    onError,
    onLoad
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("iframe", {
    "data-testid": "dynamicMap",
    src: src,
    width: "100%",
    height: "100%",
    frameBorder: "0",
    onError: onError,
    onLoad: onLoad,
    scrolling: "no",
    title: "googleMaps"
  });
};

Iframe.propTypes = {
  src: _propTypes.default.string.isRequired,
  onError: _propTypes.default.func.isRequired,
  onLoad: _propTypes.default.func.isRequired
};

var GoogleMaps = (_ref3) => {
  var {
    apiKey,
    location
  } = _ref3;
  var classes = useStyles();
  var [loaded, setLoaded] = (0, _react.useState)(false);
  var {
    href: src
  } = makeUrl(location, apiKey);

  var onError = () => {
    setLoaded(false);
  };

  var onLoad = () => {
    setLoaded(true);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "inherit",
    height: "inherit",
    style: {
      display: loaded ? 'none' : 'inherit'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      display: loaded ? 'inherit' : 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(Iframe, {
    src: src,
    onError: onError,
    onLoad: onLoad
  })));
};

GoogleMaps.propTypes = {
  /**
   * This is the api key provide by Google Maps
   */
  apiKey: _propTypes.default.string.isRequired,

  /**
   * This is location string provide by api (eg.: Toronto, Canada)
   */
  location: _propTypes.default.string.isRequired
};
var _default = GoogleMaps;
exports.default = _default;